export default __webpack_public_path__ + "static/media/Brigand's Hood of the Wicked Hearth.b6a2b199.jpg";